export default __webpack_public_path__ + "images/skolkovo_logo_hover.f154d8b7.svg";